"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var apiSociete = _interopRequireWildcard(require("@/api/societe"));

var apiAffaire = _interopRequireWildcard(require("@/api/affaire"));

var apiUser = _interopRequireWildcard(require("@/api/user"));

var apiPermission = _interopRequireWildcard(require("@/api/permission"));

var _utils = require("@/helpers/utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  props: {
    formData: Object,
    title: String,
    action: String
  },
  data: function data() {
    return {
      // ---
      hasImage: false,
      image: null,
      rules: {
        name: [{
          required: true,
          message: 'Champ obligatoire'
        }],
        shortname: [{
          required: true,
          message: 'Champ obligatoire'
        }]
      },
      nbAffaire: 0,
      refresh: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$loader(true);
    apiAffaire.getAllBySocieteId(this.formData.id).then(function (results) {
      _this.nbAffaire = results ? results.length : 0;

      _this.$loader(false);
    }).catch(function (error) {
      _this.$message(error);

      _this.$loader(false);
    });
  },
  computed: {
    disabled: function disabled() {
      return this.nbAffaire > 0;
    },
    deboursesIndirects: function deboursesIndirects() {
      return this.formData.deboursesIndirects && this.formData.deboursesIndirects.length > 0 ? JSON.parse(this.formData.deboursesIndirects) : [];
    }
  },
  methods: {
    addRow: function addRow() {
      var max = this.deboursesIndirects.length > 0 ? Math.max.apply(Math, this.deboursesIndirects.map(function (o) {
        return o.id_debourseIndirect;
      })) : 0;
      var data = {
        id_debourseIndirect: max + 1,
        titre_debourseIndirect: '',
        group_debourseIndirect: ''
      };
      this.deboursesIndirects.push(data);
    },
    deleteRow: function deleteRow(index) {
      this.deboursesIndirects.splice(index, 1);
    },
    // ==============================
    setImage: function setImage(output) {
      this.hasImage = true;
      this.image = output;
      this.formData.logo = this.image;
    },
    resetForm: function resetForm() {
      this.$refs['ElForm'].resetFields();
    },
    validateForm: function validateForm() {
      var _this2 = this;

      this.$refs['ElForm'].validate(function (valid) {
        if (valid) {
          switch (_this2.action) {
            case 'new':
              _this2.actionNew();

              break;

            case 'edit':
              _this2.actionEdit();

              break;
          }
        }
      });
    },
    actionNew: function actionNew() {
      var _this3 = this;

      var data = this.getData();
      this.$loader(true);
      apiSociete.insert(data).then(function (results) {
        var idSociete = results.insertId;

        var nameSociete = _this3.formData.name.toUpperCase();

        _this3.addSaPermission(idSociete);

        _this3.addFirstUser(idSociete, nameSociete);

        _this3.$message('Création effectuée avec succès');

        _this3.resetForm();

        _this3.$loader(false);
      }).catch(function (error) {
        _this3.$message(error);

        _this3.$loader(false);
      });
    },
    actionEdit: function actionEdit() {
      var _this4 = this;

      var data = this.getData();
      this.$loader(true);
      apiSociete.update(this.formData.id, data).then(function (results) {
        _this4.$message('Mise à jour effectuée avec succès');

        _this4.$loader(false);
      }).catch(function (error) {
        _this4.$message(error);

        _this4.$loader(false);
      });
    },
    getData: function getData() {
      var data = {
        name: this.formData.name.toUpperCase(),
        shortname: this.formData.shortname.toUpperCase(),
        actif: this.formData.actif,
        deboursesIndirects: JSON.stringify(this.deboursesIndirects)
      };
      var logo = {
        logo: this.image
      };
      return this.image ? _objectSpread({}, data, {}, logo) : data;
    },
    addFirstUser: function () {
      var _addFirstUser = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(idSociete, nameSociete) {
        var _this5 = this;

        var pwd, user;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pwd = (0, _utils.generatePassword)();
                user = {
                  id_societe: idSociete,
                  firstname: 'SA',
                  lastname: '',
                  email: 'sa_easy@marraud.com',
                  enabled: 1,
                  key_role: 'superadmin',
                  password: (0, _utils.encodePassword)(pwd),
                  notification_mail: 0
                };
                _context.next = 4;
                return apiUser.insert(user).then(function (results) {
                  var msg = '';
                  msg += 'Un super-administrateur par défaut a été créé pour vous connecter à cette nouvelle société.<br>';
                  msg += 'Veuillez noter les informations de connexion suivante:<br><br>';
                  msg += 'société: ' + nameSociete + '<br>';
                  msg += 'identifiant: ' + 'sa_easy@marraud.com' + '<br>';
                  msg += 'mot de passe: ' + pwd;

                  _this5.$alert(msg, 'Création Super-Administrateur', {
                    confirmButtonText: 'Fermer',
                    type: 'info',
                    dangerouslyUseHTMLString: true
                  });
                }).catch(function (error) {
                  _this5.$message(error);
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function addFirstUser(_x, _x2) {
        return _addFirstUser.apply(this, arguments);
      }

      return addFirstUser;
    }(),
    addSaPermission: function () {
      var _addSaPermission = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2(idSociete) {
        var _this6 = this;

        var permission;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                permission = {
                  id_societe: idSociete,
                  key_role: 'superadmin',
                  name: 'Super-Administrateur',
                  acl: '["Admin","AdminUser","ListUser","NewUser","EdituUser","AdminSociete","ListSociete","NewSociete","EditSociete","AdminPermission","ListPermission","NewPermission","EditPermission","Affaire","ListAffaire"]',
                  rules: null
                };
                _context2.next = 3;
                return apiPermission.insert(permission).then(function (results) {}).catch(function (error) {
                  _this6.$message(error);
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function addSaPermission(_x3) {
        return _addSaPermission.apply(this, arguments);
      }

      return addSaPermission;
    }()
  }
};
exports.default = _default;